import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputList from "../components/Form/UiInputList";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

const usoList = [
    { id: 'dados', title: 'Dados da obra' },
    { id: 'checklist', title: 'Checklist' },
];

/**
 * Só o template: tipo, uso, versão, ativo, publicado.
 *
 * Os campos saíram desta tela. Cada um é uma linha do grid `tarcampo`, aberto pela
 * ação "Campos" do grid de templates, e editado no form próprio, onde ajuda,
 * opções e validação cabem sem o aperto de uma linha de tabela.
 */
export default function TemplateForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { uso: 'checklist', versao: 1, ativo: true }
    });
    const { handleSubmit, reset, watch } = methods;

    const publicadoEm = watch('publicadoEm');
    const publicado = !!publicadoEm;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    {publicado && (
                        <div className="alert alert-warning">
                            <strong>Template publicado{typeof publicadoEm === 'string' ? ` em ${publicadoEm}` : ''}.</strong>{' '}
                            Os campos desta versão não mudam mais, porque as tarefas já abertas apontam para ela.
                            Para alterar o formulário, use <strong>Nova versão</strong> no grid de templates: ela
                            copia os campos para uma versão despublicada, que pode ser editada.
                        </div>
                    )}

                    <div className="row">
                        <UiInputSuggest size={12} name="tipo" router="tartipo" idField="id" titleField="nome" label="Tipo de Tarefa"/>
                        <UiInputList size={6} name="uso" list={usoList} idField="id" titleField="title" label="Uso"/>
                        <UiInputNumberInteger size={3} name="versao" label="Versão" readOnly/>
                        <UiInputCheckbox size={3} name="ativo" label="Ativo"/>
                        <UiInputText size={12} name="publicadoEm" label="Publicado em" readOnly/>
                        <div className="col-lg-12">
                            <p className="text-muted small">
                                Os campos do formulário ficam na ação <strong>Campos</strong> do grid de templates,
                                um por linha, com a obrigatoriedade no form de cada campo.
                            </p>
                        </div>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
